module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-form', {
    attrs: {
      "entity": _vm.reader,
      "fields": _vm.fields,
      "model": "readers",
      "cancel": false
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-161d8b56!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reader/ReaderForm.vue
// module id = 976
// module chunks = 2